import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './authGuard'
import { installNavigationRecovery } from '@/utils/navigationRecovery'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      name: 'overview',
      component: () => import('@/views/PulseView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/classic',
      name: 'classic-overview',
      component: () => import('@/views/OverviewView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/activation',
      name: 'activation',
      component: () => import('@/views/ActivationView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/accounts/:orgId?',
      name: 'customer-360',
      component: () => import('@/views/Customer360View.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import('@/views/CustomersView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/revenue',
      name: 'revenue',
      component: () => import('@/views/RevenueView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/experiments',
      name: 'experiments',
      component: () => import('@/views/ExperimentsView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/users',
      redirect: '/customers',
    },
    // Hidden from nav. Uncomment to restore.
    // {
    //   path: '/marketing/brands',
    //   name: 'marketing-brands',
    //   component: () => import('@/views/BrandsPlaceholderView.vue'),
    // },
    // {
    //   path: '/marketing/youtube',
    //   name: 'marketing-youtube',
    //   component: () => import('@/views/YoutubeView.vue'),
    // },
    // {
    //   path: '/lead-magnets',
    //   name: 'lead-magnets',
    //   component: () => import('@/views/LeadMagnetSignupsView.vue'),
    // },
    // {
    //   path: '/scraping/apollo',
    //   name: 'scraping-apollo',
    //   component: () => import('@/views/ScrapingApolloView.vue'),
    // },

    {
      path: '/setup-leads',
      name: 'setup-leads',
      component: () => import('@/views/SetupLeadsView.vue'),
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: () => import('@/views/OnboardingOperationsView.vue'),
    },
    {
      path: '/agent-conversations',
      name: 'agent-conversations',
      component: () => import('@/views/AgentConversationsView.vue'),
    },
    {
      path: '/agent-capability-requests',
      name: 'agent-capability-requests',
      component: () => import('@/views/AgentCapabilityRequestsView.vue'),
    },
    {
      path: '/user-feedback/:id?',
      name: 'user-feedback',
      component: () => import('@/views/UserFeedbackView.vue'),
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('@/views/AnalyticsView.vue'),
      meta: { guestAllowed: true },
    },
    {
      path: '/ambassador-applications/:id?',
      name: 'ambassador-applications',
      component: () => import('@/views/AmbassadorApplicationsView.vue'),
    },
    {
      path: '/referrals/:partnerId?',
      name: 'referrals',
      component: () => import('@/views/ReferralsView.vue'),
    },
    {
      path: '/ai-spend',
      name: 'ai-spend',
      component: () => import('@/views/AiSpendView.vue'),
    },
    {
      path: '/voice-skills',
      name: 'voice-skills',
      component: () => import('@/views/VoiceSkillsView.vue'),
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: () => import('@/views/AnnouncementsView.vue'),
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/views/NotificationsView.vue'),
    },
    {
      path: '/email-ops',
      name: 'email-ops',
      component: () => import('@/views/EmailOpsView.vue'),
    },
    {
      path: '/sessions',
      name: 'sessions',
      component: () => import('@/views/SessionsView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

installNavigationRecovery(router)
router.beforeEach(authGuard)

export default router
